// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/capture_outputs.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3 } from "@bufbuild/protobuf";
import { CaptureOutputChange, CaptureOutputContext, CaptureOutputDisposition, CaptureOutputHandoff, CaptureOutputMaterial, CaptureOutputOverride, CaptureOutputOverrideDecision, CaptureOutputPresentation, CaptureOutputProjection, CaptureOutputSnapshot, CaptureOutputStalenessEvent, CaptureOutputVersion } from "../../datagateway/v1/capture_outputs_pb";
/**
 * Tenant and actor always come from the authenticated gateway principal.
 *
 * @generated from message mono.projectdata.v1.GetCaptureOutputsRequest
 */ export class GetCaptureOutputsRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureOutputsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureOutputsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureOutputsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureOutputsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string template_id = 2;
   */ _define_property(this, "templateId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureOutputsRequest, "runtime", proto3);
_define_property(GetCaptureOutputsRequest, "typeName", "mono.projectdata.v1.GetCaptureOutputsRequest");
_define_property(GetCaptureOutputsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "template_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SaveCaptureOutputMaterialRequest
 */ export class SaveCaptureOutputMaterialRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveCaptureOutputMaterialRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveCaptureOutputMaterialRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveCaptureOutputMaterialRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveCaptureOutputMaterialRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string section_key = 2;
   */ _define_property(this, "sectionKey", ""), /**
   * @generated from field: int32 expected_version = 3;
   */ _define_property(this, "expectedVersion", 0), /**
   * @generated from field: string narrative = 4;
   */ _define_property(this, "narrative", ""), /**
   * @generated from field: string evidence = 5;
   */ _define_property(this, "evidence", ""), /**
   * @generated from field: string limitations = 6;
   */ _define_property(this, "limitations", ""), /**
   * @generated from field: bool reviewed = 7;
   */ _define_property(this, "reviewed", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveCaptureOutputMaterialRequest, "runtime", proto3);
_define_property(SaveCaptureOutputMaterialRequest, "typeName", "mono.projectdata.v1.SaveCaptureOutputMaterialRequest");
_define_property(SaveCaptureOutputMaterialRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "expected_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "evidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "limitations",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "reviewed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SaveCaptureOutputSnapshotRequest
 */ export class SaveCaptureOutputSnapshotRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveCaptureOutputSnapshotRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveCaptureOutputSnapshotRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveCaptureOutputSnapshotRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveCaptureOutputSnapshotRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string template_id = 2;
   */ _define_property(this, "templateId", ""), /**
   * @generated from field: string purpose = 3;
   */ _define_property(this, "purpose", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveCaptureOutputSnapshotRequest, "runtime", proto3);
_define_property(SaveCaptureOutputSnapshotRequest, "typeName", "mono.projectdata.v1.SaveCaptureOutputSnapshotRequest");
_define_property(SaveCaptureOutputSnapshotRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "template_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "purpose",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCaptureOutputSnapshotsRequest
 */ export class ListCaptureOutputSnapshotsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureOutputSnapshotsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureOutputSnapshotsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureOutputSnapshotsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureOutputSnapshotsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureOutputSnapshotsRequest, "runtime", proto3);
_define_property(ListCaptureOutputSnapshotsRequest, "typeName", "mono.projectdata.v1.ListCaptureOutputSnapshotsRequest");
_define_property(ListCaptureOutputSnapshotsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetCaptureOutputsResponse
 */ export class GetCaptureOutputsResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureOutputsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureOutputsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureOutputsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureOutputsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputProjection projection = 1;
   */ _define_property(this, "projection", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureOutputMaterial material_history = 2;
   */ _define_property(this, "materialHistory", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureOutputsResponse, "runtime", proto3);
_define_property(GetCaptureOutputsResponse, "typeName", "mono.projectdata.v1.GetCaptureOutputsResponse");
_define_property(GetCaptureOutputsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "projection",
            kind: "message",
            T: CaptureOutputProjection
        },
        {
            no: 2,
            name: "material_history",
            kind: "message",
            T: CaptureOutputMaterial,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SaveCaptureOutputMaterialResponse
 */ export class SaveCaptureOutputMaterialResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveCaptureOutputMaterialResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveCaptureOutputMaterialResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveCaptureOutputMaterialResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveCaptureOutputMaterialResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputMaterial material = 1;
   */ _define_property(this, "material", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveCaptureOutputMaterialResponse, "runtime", proto3);
_define_property(SaveCaptureOutputMaterialResponse, "typeName", "mono.projectdata.v1.SaveCaptureOutputMaterialResponse");
_define_property(SaveCaptureOutputMaterialResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "material",
            kind: "message",
            T: CaptureOutputMaterial
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SaveCaptureOutputSnapshotResponse
 */ export class SaveCaptureOutputSnapshotResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveCaptureOutputSnapshotResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveCaptureOutputSnapshotResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveCaptureOutputSnapshotResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveCaptureOutputSnapshotResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputSnapshot snapshot = 1;
   */ _define_property(this, "snapshot", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveCaptureOutputSnapshotResponse, "runtime", proto3);
_define_property(SaveCaptureOutputSnapshotResponse, "typeName", "mono.projectdata.v1.SaveCaptureOutputSnapshotResponse");
_define_property(SaveCaptureOutputSnapshotResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "snapshot",
            kind: "message",
            T: CaptureOutputSnapshot
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCaptureOutputSnapshotsResponse
 */ export class ListCaptureOutputSnapshotsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureOutputSnapshotsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureOutputSnapshotsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureOutputSnapshotsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureOutputSnapshotsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureOutputSnapshot snapshots = 1;
   */ _define_property(this, "snapshots", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureOutputSnapshotsResponse, "runtime", proto3);
_define_property(ListCaptureOutputSnapshotsResponse, "typeName", "mono.projectdata.v1.ListCaptureOutputSnapshotsResponse");
_define_property(ListCaptureOutputSnapshotsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "snapshots",
            kind: "message",
            T: CaptureOutputSnapshot,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReviewCaptureOutputRequest
 */ export class ReviewCaptureOutputRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReviewCaptureOutputRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewCaptureOutputRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewCaptureOutputRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewCaptureOutputRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string template_id = 2;
   */ _define_property(this, "templateId", ""), /**
   * @generated from field: string version_id = 3;
   */ _define_property(this, "versionId", ""), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputContext context = 4;
   */ _define_property(this, "context", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewCaptureOutputRequest, "runtime", proto3);
_define_property(ReviewCaptureOutputRequest, "typeName", "mono.projectdata.v1.ReviewCaptureOutputRequest");
_define_property(ReviewCaptureOutputRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "template_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "context",
            kind: "message",
            T: CaptureOutputContext
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SaveCaptureOutputVersionRequest
 */ export class SaveCaptureOutputVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveCaptureOutputVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveCaptureOutputVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveCaptureOutputVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveCaptureOutputVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string template_id = 2;
   */ _define_property(this, "templateId", ""), /**
   * @generated from field: string operation = 3;
   */ _define_property(this, "operation", ""), /**
   * @generated from field: string expected_head_id = 4;
   */ _define_property(this, "expectedHeadId", ""), /**
   * @generated from field: string reviewed_source_fingerprint = 5;
   */ _define_property(this, "reviewedSourceFingerprint", ""), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureOutputOverride overrides = 6;
   */ _define_property(this, "overrides", []), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureOutputOverrideDecision decisions = 7;
   */ _define_property(this, "decisions", []), /**
   * @generated from field: string artifact_id = 8;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputContext context = 9;
   */ _define_property(this, "context", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveCaptureOutputVersionRequest, "runtime", proto3);
_define_property(SaveCaptureOutputVersionRequest, "typeName", "mono.projectdata.v1.SaveCaptureOutputVersionRequest");
_define_property(SaveCaptureOutputVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "template_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "operation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "expected_head_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "reviewed_source_fingerprint",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "overrides",
            kind: "message",
            T: CaptureOutputOverride,
            repeated: true
        },
        {
            no: 7,
            name: "decisions",
            kind: "message",
            T: CaptureOutputOverrideDecision,
            repeated: true
        },
        {
            no: 8,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "context",
            kind: "message",
            T: CaptureOutputContext
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCaptureOutputVersionsRequest
 */ export class ListCaptureOutputVersionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureOutputVersionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureOutputVersionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureOutputVersionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureOutputVersionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string template_id = 2;
   */ _define_property(this, "templateId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureOutputVersionsRequest, "runtime", proto3);
_define_property(ListCaptureOutputVersionsRequest, "typeName", "mono.projectdata.v1.ListCaptureOutputVersionsRequest");
_define_property(ListCaptureOutputVersionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "template_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReviewCaptureOutputResponse
 */ export class ReviewCaptureOutputResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReviewCaptureOutputResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewCaptureOutputResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewCaptureOutputResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewCaptureOutputResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputVersion current = 1;
   */ _define_property(this, "current", void 0), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputProjection prospective = 2;
   */ _define_property(this, "prospective", void 0), /**
   * @generated from field: string source_fingerprint = 3;
   */ _define_property(this, "sourceFingerprint", ""), /**
   * @generated from field: string head_id = 4;
   */ _define_property(this, "headId", ""), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureOutputStalenessEvent history = 5;
   */ _define_property(this, "history", []), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureOutputChange changes = 6;
   */ _define_property(this, "changes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewCaptureOutputResponse, "runtime", proto3);
_define_property(ReviewCaptureOutputResponse, "typeName", "mono.projectdata.v1.ReviewCaptureOutputResponse");
_define_property(ReviewCaptureOutputResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "current",
            kind: "message",
            T: CaptureOutputVersion
        },
        {
            no: 2,
            name: "prospective",
            kind: "message",
            T: CaptureOutputProjection
        },
        {
            no: 3,
            name: "source_fingerprint",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "head_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "history",
            kind: "message",
            T: CaptureOutputStalenessEvent,
            repeated: true
        },
        {
            no: 6,
            name: "changes",
            kind: "message",
            T: CaptureOutputChange,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SaveCaptureOutputVersionResponse
 */ export class SaveCaptureOutputVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveCaptureOutputVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveCaptureOutputVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveCaptureOutputVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveCaptureOutputVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputVersion version = 1;
   */ _define_property(this, "version", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveCaptureOutputVersionResponse, "runtime", proto3);
_define_property(SaveCaptureOutputVersionResponse, "typeName", "mono.projectdata.v1.SaveCaptureOutputVersionResponse");
_define_property(SaveCaptureOutputVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "message",
            T: CaptureOutputVersion
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCaptureOutputVersionsResponse
 */ export class ListCaptureOutputVersionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureOutputVersionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureOutputVersionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureOutputVersionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureOutputVersionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureOutputVersion versions = 1;
   */ _define_property(this, "versions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureOutputVersionsResponse, "runtime", proto3);
_define_property(ListCaptureOutputVersionsResponse, "typeName", "mono.projectdata.v1.ListCaptureOutputVersionsResponse");
_define_property(ListCaptureOutputVersionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "versions",
            kind: "message",
            T: CaptureOutputVersion,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateCaptureOutputHandoffRequest
 */ export class CreateCaptureOutputHandoffRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateCaptureOutputHandoffRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCaptureOutputHandoffRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCaptureOutputHandoffRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCaptureOutputHandoffRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string proposal_project_id = 2;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string output_version_id = 3;
   */ _define_property(this, "outputVersionId", ""), /**
   * @generated from field: repeated string section_keys = 4;
   */ _define_property(this, "sectionKeys", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCaptureOutputHandoffRequest, "runtime", proto3);
_define_property(CreateCaptureOutputHandoffRequest, "typeName", "mono.projectdata.v1.CreateCaptureOutputHandoffRequest");
_define_property(CreateCaptureOutputHandoffRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "output_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "section_keys",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateCaptureOutputHandoffResponse
 */ export class CreateCaptureOutputHandoffResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateCaptureOutputHandoffResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCaptureOutputHandoffResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCaptureOutputHandoffResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCaptureOutputHandoffResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputHandoff handoff = 1;
   */ _define_property(this, "handoff", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCaptureOutputHandoffResponse, "runtime", proto3);
_define_property(CreateCaptureOutputHandoffResponse, "typeName", "mono.projectdata.v1.CreateCaptureOutputHandoffResponse");
_define_property(CreateCaptureOutputHandoffResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "handoff",
            kind: "message",
            T: CaptureOutputHandoff
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCaptureOutputHandoffsRequest
 */ export class ListCaptureOutputHandoffsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureOutputHandoffsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureOutputHandoffsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureOutputHandoffsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureOutputHandoffsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string proposal_project_id = 1;
   */ _define_property(this, "proposalProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureOutputHandoffsRequest, "runtime", proto3);
_define_property(ListCaptureOutputHandoffsRequest, "typeName", "mono.projectdata.v1.ListCaptureOutputHandoffsRequest");
_define_property(ListCaptureOutputHandoffsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCaptureOutputHandoffsResponse
 */ export class ListCaptureOutputHandoffsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureOutputHandoffsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureOutputHandoffsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureOutputHandoffsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureOutputHandoffsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureOutputHandoff handoffs = 1;
   */ _define_property(this, "handoffs", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureOutputHandoffsResponse, "runtime", proto3);
_define_property(ListCaptureOutputHandoffsResponse, "typeName", "mono.projectdata.v1.ListCaptureOutputHandoffsResponse");
_define_property(ListCaptureOutputHandoffsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "handoffs",
            kind: "message",
            T: CaptureOutputHandoff,
            repeated: true
        }
    ]));
/**
 * SAD-510: settings and explicit authority reference an immutable output version.
 *
 * @generated from message mono.projectdata.v1.GetCaptureOutputPresentationRequest
 */ export class GetCaptureOutputPresentationRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureOutputPresentationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureOutputPresentationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureOutputPresentationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureOutputPresentationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string output_version_id = 2;
   */ _define_property(this, "outputVersionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureOutputPresentationRequest, "runtime", proto3);
_define_property(GetCaptureOutputPresentationRequest, "typeName", "mono.projectdata.v1.GetCaptureOutputPresentationRequest");
_define_property(GetCaptureOutputPresentationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "output_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetCaptureOutputPresentationResponse
 */ export class GetCaptureOutputPresentationResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureOutputPresentationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureOutputPresentationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureOutputPresentationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureOutputPresentationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputPresentation presentation = 1;
   */ _define_property(this, "presentation", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureOutputDisposition dispositions = 2;
   */ _define_property(this, "dispositions", []), /**
   * @generated from field: repeated string allowed_actions = 3;
   */ _define_property(this, "allowedActions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureOutputPresentationResponse, "runtime", proto3);
_define_property(GetCaptureOutputPresentationResponse, "typeName", "mono.projectdata.v1.GetCaptureOutputPresentationResponse");
_define_property(GetCaptureOutputPresentationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "presentation",
            kind: "message",
            T: CaptureOutputPresentation
        },
        {
            no: 2,
            name: "dispositions",
            kind: "message",
            T: CaptureOutputDisposition,
            repeated: true
        },
        {
            no: 3,
            name: "allowed_actions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SaveCaptureOutputPresentationRequest
 */ export class SaveCaptureOutputPresentationRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveCaptureOutputPresentationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveCaptureOutputPresentationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveCaptureOutputPresentationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveCaptureOutputPresentationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string output_version_id = 2;
   */ _define_property(this, "outputVersionId", ""), /**
   * @generated from field: int32 expected_revision = 3;
   */ _define_property(this, "expectedRevision", 0), /**
   * @generated from field: string theme = 4;
   */ _define_property(this, "theme", ""), /**
   * @generated from field: string layout = 5;
   */ _define_property(this, "layout", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveCaptureOutputPresentationRequest, "runtime", proto3);
_define_property(SaveCaptureOutputPresentationRequest, "typeName", "mono.projectdata.v1.SaveCaptureOutputPresentationRequest");
_define_property(SaveCaptureOutputPresentationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "output_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "expected_revision",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "theme",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "layout",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SaveCaptureOutputPresentationResponse
 */ export class SaveCaptureOutputPresentationResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveCaptureOutputPresentationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveCaptureOutputPresentationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveCaptureOutputPresentationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveCaptureOutputPresentationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputPresentation presentation = 1;
   */ _define_property(this, "presentation", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveCaptureOutputPresentationResponse, "runtime", proto3);
_define_property(SaveCaptureOutputPresentationResponse, "typeName", "mono.projectdata.v1.SaveCaptureOutputPresentationResponse");
_define_property(SaveCaptureOutputPresentationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "presentation",
            kind: "message",
            T: CaptureOutputPresentation
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RecordCaptureOutputDispositionRequest
 */ export class RecordCaptureOutputDispositionRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordCaptureOutputDispositionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordCaptureOutputDispositionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordCaptureOutputDispositionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordCaptureOutputDispositionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string output_version_id = 2;
   */ _define_property(this, "outputVersionId", ""), /**
   * @generated from field: int32 presentation_revision = 3;
   */ _define_property(this, "presentationRevision", 0), /**
   * @generated from field: string action = 4;
   */ _define_property(this, "action", ""), /**
   * @generated from field: string reason = 5;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordCaptureOutputDispositionRequest, "runtime", proto3);
_define_property(RecordCaptureOutputDispositionRequest, "typeName", "mono.projectdata.v1.RecordCaptureOutputDispositionRequest");
_define_property(RecordCaptureOutputDispositionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "output_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "presentation_revision",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RecordCaptureOutputDispositionResponse
 */ export class RecordCaptureOutputDispositionResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordCaptureOutputDispositionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordCaptureOutputDispositionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordCaptureOutputDispositionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordCaptureOutputDispositionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputDisposition disposition = 1;
   */ _define_property(this, "disposition", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordCaptureOutputDispositionResponse, "runtime", proto3);
_define_property(RecordCaptureOutputDispositionResponse, "typeName", "mono.projectdata.v1.RecordCaptureOutputDispositionResponse");
_define_property(RecordCaptureOutputDispositionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "disposition",
            kind: "message",
            T: CaptureOutputDisposition
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ExportCaptureOutputRequest
 */ export class ExportCaptureOutputRequest extends Message {
    static fromBinary(bytes, options) {
        return new ExportCaptureOutputRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExportCaptureOutputRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExportCaptureOutputRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExportCaptureOutputRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string output_version_id = 2;
   */ _define_property(this, "outputVersionId", ""), /**
   * @generated from field: int32 presentation_revision = 3;
   */ _define_property(this, "presentationRevision", 0), /**
   * @generated from field: string format = 4;
   */ _define_property(this, "format", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExportCaptureOutputRequest, "runtime", proto3);
_define_property(ExportCaptureOutputRequest, "typeName", "mono.projectdata.v1.ExportCaptureOutputRequest");
_define_property(ExportCaptureOutputRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "output_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "presentation_revision",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ExportCaptureOutputResponse
 */ export class ExportCaptureOutputResponse extends Message {
    static fromBinary(bytes, options) {
        return new ExportCaptureOutputResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExportCaptureOutputResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExportCaptureOutputResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExportCaptureOutputResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bytes content = 1;
   */ _define_property(this, "content", new Uint8Array(0)), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string mime_type = 3;
   */ _define_property(this, "mimeType", ""), /**
   * @generated from field: string output_version_id = 4;
   */ _define_property(this, "outputVersionId", ""), /**
   * @generated from field: string authorization_id = 5;
   */ _define_property(this, "authorizationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExportCaptureOutputResponse, "runtime", proto3);
_define_property(ExportCaptureOutputResponse, "typeName", "mono.projectdata.v1.ExportCaptureOutputResponse");
_define_property(ExportCaptureOutputResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "content",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "output_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "authorization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
